import { render, staticRenderFns } from "./thirdSection.vue?vue&type=template&id=0ed4bdd4"
import script from "./thirdSection.vue?vue&type=script&lang=js"
export * from "./thirdSection.vue?vue&type=script&lang=js"
import style0 from "./thirdSection.vue?vue&type=style&index=0&id=0ed4bdd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports